import { Box, Stack } from "@mui/joy";
import { forwardRef } from "react";
import { useRecoilValue } from "recoil";
import { layoutAtom } from "recoil/layoutAtom";
import { theme } from "styles/theme";
import useBottomSafePadding from "hooks/useBottomSafePadding";

interface FloatingAreaProps {
  fullWidth: boolean;
  children: React.ReactNode;
  noDivider?: boolean;
  backgroundColor?: string;
  paddingBottom?: string;
}

const FloatingArea = forwardRef<HTMLDivElement, FloatingAreaProps>(
  (
    {
      children,
      noDivider,
      fullWidth,
      backgroundColor = theme.vars.palette.Background.Level1,
      paddingBottom,
    },
    ref
  ) => {
    const { isLeftSideBarOpen, taskWidth } = useRecoilValue(layoutAtom);
    const pb = useBottomSafePadding(paddingBottom ?? "12px");

    return (
      <Box
        ref={ref}
        sx={{
          position: "fixed",
          zIndex: 10,
          bottom: 0,
          // calc() 없이는 var 합산이 무효 CSS 라 left 가 0 으로 폴백 → 본문보다 좌측으로 치우침.
          left: fullWidth
            ? 0
            : "calc(var(--Sidebar-width, 0px) + var(--PC-SideTab-width, 0px))",
          width: fullWidth
            ? "100%"
            : `calc(100% - var(--Sidebar-width, 0) - var(--PC-SideTab-width, 0))`,
          pointerEvents: "none",
        }}
      >
        <Box
          sx={{
            backgroundColor: backgroundColor,
            boxShadow: noDivider ? "none" : "0px 1px 0px 0px #00000014 inset;",
            px: "20px",
            pt: "12px",
            // paddingBottom prop 은 "최소 여백" 의미 (env=0 환경에서 보장).
            // Android in-app 은 RN 외부 패딩이 있으므로 0 을 반환해 중복 방지.
            pb,
            pointerEvents: "auto",
            WebkitTextSizeAdjust: "100%",
            textSizeAdjust: "100%",
          }}
        >
          <Stack
            className={` w-full ${
              taskWidth === "normal" && "max-w-[660px] mx-auto"
            }`}
            alignItems="center"
          >
            {children}
          </Stack>
        </Box>
      </Box>
    );
  }
);

export default FloatingArea;
